import React from 'react';
import * as styles from './FaqItems.scss';
import { Accordion, AccordionWrapper } from '@/lazyImports';
import { IFaqItem } from '@/api/faq';
import { AccordionIcon } from '@/components/common/accordion-wrapper/accordion/accordionIcon';
import { useIsMobileDeviceView } from '@/hooks/useIsMobileDeviceView';

interface IFaqItemsProps {
    items: IFaqItem[];
    isActive: boolean;
    title: string;
    expandedAccordionId: number | null;
}

export const FaqItems: React.FC<IFaqItemsProps> = ({ items, title, isActive, expandedAccordionId }) => {
    const { isInMobileView } = useIsMobileDeviceView();

    return (
        <div className={`${styles.content} ${isActive ? styles['content--active'] : ''}`}>
            {!isInMobileView && <h3 className={styles.header}>{title}</h3>}
            <AccordionWrapper expandedAccordionIdProp={expandedAccordionId} shouldExpandFirstAccordion={false}>
                {items.map((item, index) => (
                    <Accordion
                        iconType={AccordionIcon.ICON_PLUS}
                        classes={{
                            header: styles.accordionHeader,
                            mathSymbolIcons: styles.accordionHeaderIcons,
                        }}
                        key={index}
                        id={item.id}
                        label={item.question}
                        description={item.answer}
                    />
                ))}
            </AccordionWrapper>
        </div>
    );
};
